module.exports = __webpack_public_path__ + "img/retrofit-details-7.4e91201c.png";